import {
  VStack,
  HStack,
  Link,
  Text,
  Icon,
  Box,
} from '@chakra-ui/react';
import { MdOpenInNew, MdAttachFile } from 'react-icons/md';
import { Modal } from './Modal';

interface DocumentsDialogProps {
  isOpen: boolean;
  onClose: () => void;
  documentLinks: string[];
  taskName: string;
}

export function DocumentsDialog({ isOpen, onClose, documentLinks, taskName }: DocumentsDialogProps) {
  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title={`Reference Documents — ${taskName}`}
      size="md"
    >
      <VStack spacing={3} align="stretch" py={2}>
        {documentLinks.length === 0 ? (
          <Text color="text-secondary" fontSize="sm">No documents attached.</Text>
        ) : (
          documentLinks.map((url, index) => {
            let displayText: string;
            try {
              const parsed = new URL(url);
              const parts = parsed.pathname.split('/').filter(Boolean);
              displayText = parts[parts.length - 1] || parsed.hostname;
            } catch {
              displayText = url;
            }
            return (
              <Box
                key={index}
                p={3}
                borderWidth="1px"
                borderColor="border-default"
                borderRadius="md"
                bg="bg-surface"
                _hover={{ borderColor: 'brand.500' }}
                transition="border-color 0.15s"
              >
                <HStack spacing={2}>
                  <Icon as={MdAttachFile} color="purple.400" boxSize={4} flexShrink={0} />
                  <Link
                    href={url}
                    isExternal
                    color="brand.500"
                    fontSize="sm"
                    isTruncated
                    flex={1}
                    minW={0}
                    title={url}
                  >
                    {displayText}
                  </Link>
                  <Icon as={MdOpenInNew} color="text-muted" boxSize={3} flexShrink={0} />
                </HStack>
              </Box>
            );
          })
        )}
      </VStack>
    </Modal>
  );
}
